import { native, loader } from '@ali/amap-lib';
import api from '../../../../config/config.aos';

export default {
  data() {
    return {
      weather: {}, // 天气信息
      isShowWeather: false, // 是否显示天气模块
    };
  },
  methods: {
    // 请求天气接口
    getWeatherAosData() {
      native.getMapLocation((locInfo) => {
        const adcode = locInfo.adcode ? locInfo.adcode : '';
        const lon = locInfo.lon ? locInfo.lon : 0;
        const lat = locInfo.lat ? locInfo.lat : 0;
        if (lon !== 0 && lat !== 0 && adcode) {
          const params = [
            { adcodes: adcode },
            { lon, sign: 1 },
            { lat, sign: 1 },
            { image_standard: 1 },
            { aqi: 1 },
            { forecast: 1 },
            { local_desc: 1 },
          ];
          loader.get(api.weather, params, (res) => {
            console.log('getWeatherAosData', res);
            if (Number(res.code) === 1) {
              // 天气预警
              const warnData = res.data.emergency_weather;
              if (warnData && warnData.code && Number(warnData.code) === 1) {
                this.weather.warning_code = (warnData.data[0] && warnData.data[0].events[0] && warnData.data[0].events[0].type_code) || null;
                // this.weather.warning_level = (warnData.data[0] && warnData.data[0].events[0] && warnData.data[0].events[0].level) || null;
              }
              // 墨迹天气
              const weatherData = res.data.mojiweather;
              if (weatherData && weatherData.code && Number(weatherData.code) === 1) {
                this.weather.timestamp = weatherData.timestamp;
                // 温度
                this.weather.temperature = weatherData.temperature || null;
                this.weather.temp_high = (weatherData.forecast[0] && weatherData.forecast[0].temp_high) || null;
                this.weather.temp_low = (weatherData.forecast[0] && weatherData.forecast[0].temp_low) || null;
                // 地区、天气状况
                this.weather.local_city = (weatherData.local_info && weatherData.local_info.city) || null;
                this.weather.weather_num = weatherData.weather_icon_num || null;
                this.weather.weather_condition = weatherData.weather_condition || null;
                // 空气质量
                this.weather.aqi_value = (weatherData.aqi && weatherData.aqi.value) || null;
                // 检查是否展示，如果墨迹天气没有则不需要展示
                this.checkIsShowWeather();
              }
            }
          }, '', false);
        }
      });
    },
    // 检查是否显示天气卡片接口
    checkIsShowWeather() {
      let flag = true;
      const temp = this.weather.temperature;
      const high = this.weather.temp_high;
      const low = this.weather.temp_low;
      const local = this.weather.local_city;
      const weatherNum = this.weather.weather_num;
      const weather = this.weather.weather_condition;

      if (!temp || !high || !low) {
        flag = false;
      }
      if (!local || !weatherNum || !weather) {
        flag = false;
      }

      if (flag) {
        this.isShowWeather = true;
      }
    },
  }
};
